import { Dispatch, SetStateAction } from 'react'
import { Link, Typography } from '@mui/material'

import FullScreenModal from '../../../components/full-screen-modal'
import useStyles from '../index.styles'

interface IProps {
  modalVisible: boolean
  setModalVisible: Dispatch<SetStateAction<boolean>>
}

const ModalContent = () => {
  const classes = useStyles

  return (
    <Typography variant="body1">
      Your sensor is already protecting you. If water is detected, your sensor will beep.
      <br />
      <br />
      Remote alerts (SMS, push, email, phone) will be enabled once the sensor connects, which may take 1–2 days.
      <br />
      <br />
      For best network connection,&nbsp;
      <Link
        href="https://resources.meshify.com/defender-slim/#improve-connectivity"
        rel="noopener noreferrer"
        target="_blank"
        underline="hover"
        sx={classes.drawerLink}
      >
        check out these quick tips.
      </Link>
    </Typography>
  )
}

const SlimConnectingModal = (props: IProps) => {
  const { modalVisible, setModalVisible } = props

  return (
    <FullScreenModal
      open={modalVisible}
      onClose={() => setModalVisible(false)}
      title="Connecting to Network"
      showCloseIcon={true}
      confirmLabel="Okay, got it"
      onConfirm={() => setModalVisible(false)}
      isFullScreen={false}
    >
      <ModalContent />
    </FullScreenModal>
  )
}

export default SlimConnectingModal
